import React from 'react'
import { seriliazeParams } from '../../../helpers/seriliazeParams';
import { get_checkride_table, get_test_event_listing } from '../../../Services/employee';
import { Link } from "react-router-dom";
import moment from 'moment';
import { useHistory } from "react-router-dom";
import { useEffect } from 'react';
import { incidentTableColumns } from "../../../Components/TableComponents/constants";
import { Modal, Spin } from "antd";
import AttachFilesIncident from "../../../Components/AttachmentFiles/AttachFIlesIncident";
import { LoadingOutlined, UploadOutlined } from "@ant-design/icons";
import { useState } from 'react';
import { ValidateDate, showText } from '../../../helpers/textValidation';
import { Button } from 'antd';
import { additionalFilesIncident, incidentFields, incidentFieldsByID } from '../../../Services/hr';
import DynamicTable from '../../../Components/TableComponents/DynamicTable';
import roleManager from '../../../Components/roles';

const IncidentTab = () => {


    const history = useHistory();
    const [additionalFiles, setAdditionalFiles] = useState([]);
    const [AttLoading, setAttLoading] = useState(false)
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [uploadedFiles, setUploadedFiles] = useState([])
    const [incidentId, setincidentId] = useState(null)
    const [IncidentTabData, setIncidentTabData] = useState({ header: [], rows: [] })
    const removeFile = (fileIndexToOptOut) => {
        const files = Array.from(additionalFiles).filter(
            (files, fileIndex) => fileIndex !== fileIndexToOptOut
        );

        setAdditionalFiles(files);
    };
    const handleViewIncident = async (id) => history?.push(`/enter-incident/${id} ` )
    const handleAddEvent = (event, tabIndex) => {
        history.push(event);
      }
    const getIncidentData = async (offset = 0, limit = 10) => {
        let params = '?'.concat(seriliazeParams({ offset, limit }))
        let res = await incidentFields()
        if (res?.success) {
            setIncidentTabData(
                {
                    header: incidentTableColumns,
                    rows: res?.Incidents?.map(row => [
                        row?.id,
                        ValidateDate(row?.IncidentDate),
                        showText(row?.IncidentTime),
                        showText(row?.TGSLocation?.name),
                        showText(row?.IncidentType?.Type),
                        <Button className="ViewIcon" onClick={() => handleViewIncident(row?.id)}><p></p></Button>,
                        <div
                            onClick={() => onClickViewAttachment(row?.id)}
                            style={{ display: "flex", alignItems: "center", justifyContent: "center", marginLeft: "-20px", cursor: "pointer" }}>
                            <UploadOutlined style={{ background: "#2963AD", padding: "7px", borderRadius: "100%", color: "white" }} />
                        </div>,
                        [undefined, null, "", "Invalid date"].includes(row?.ClosedDate) ? "Open" : "Closed"
                    ])
                }
            )
        }
    }
    const onClickViewAttachment = async (id) => {
        setAttLoading(true)

        setincidentId(id)
        setIsModalOpen(true)
        let res = await incidentFieldsByID(id)
        setUploadedFiles(res?.files)
        // setisFinalized(res?.data?.isFinalized)
        setAttLoading(false)

    }
    const onSubmitEmploye = async () => {
        setAttLoading(true)
        if (incidentId) {
            const formData = new FormData();

            Array.from(additionalFiles).forEach((file) => {
                formData.append("file", file);
            });

            const response = await additionalFilesIncident({
                incidentId,
                formData,
            })
            if (response?.httpStatus === 200) {
                setIsModalOpen(false)
                setAdditionalFiles([])
                await fetchIncidentFields()
            }
            setAttLoading(false)

        }
    }
    const fetchIncidentFields = async () => {
        let res = await incidentFields()

        let data = {
            header: incidentTableColumns,
            rows: res?.Incidents?.map(row => [
                row?.id,
                ValidateDate(row?.IncidentDate),
                showText(row?.IncidentTime),
                showText(row?.TGSLocation?.name),
                showText(row?.IncidentType?.Type),
                <Button className="ViewIcon" onClick={() => handleViewIncident(row?.id)}></Button>,
                <div
                    onClick={() => onClickViewAttachment(row?.id)}
                    style={{ display: "flex", alignItems: "center", justifyContent: "center", marginLeft: "-20px", cursor: "pointer" }}>
                    <UploadOutlined
                        style={{ background: "#2963AD", padding: "7px", borderRadius: "100%", color: "white" }} />
                </div>,
                [undefined, null, "", "Invalid date"].includes(row?.ClosedDate) ? "Open" : "Closed"
            ])
        }
        return data

    }
    const attatchmentFilesdata = {
        additionalFiles,
        setAdditionalFiles,
        removeFile,
        uploadedFiles,
        incidentId
    };
    useEffect(() => {
        getIncidentData()
    }, [])
    return (
        <>
        <div style={{marginBottom:'15px'}}>
        {roleManager("safetyTesting", "Createincident") &&
              <Button
                onClick={handleAddEvent.bind(null, 'enter-incident', 2)}
                style={{background:'#2963AD ',color:'white',borderRadius:"10px",height:'50px'}} >
                Enter Incident
              </Button>
            }
        </div>
            <DynamicTable tableData={IncidentTabData} />
            <Modal
                title="Attachments"
                // closeIcon={<></>}
                style={{
                    top: 20,
                }}
                width={"60%"}
                open={isModalOpen}
                onOk={() => setIsModalOpen(false)}
                onCancel={() => setIsModalOpen(false)}
                footer={false}
            >
                <Spin
                    spinning={AttLoading || false}
                    indicator={<LoadingOutlined
                        style={{
                            fontSize: 24,
                        }}
                        spin
                    />}>

                    <AttachFilesIncident data={attatchmentFilesdata} />
                    <div
                        // stlye={{ width: "100%" }}
                        style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", }}
                        onClick={() => onSubmitEmploye()}
                    >
                        {additionalFiles?.length ? <span style={{ background: "#2963AD", padding: "10px 15px", color: "white", borderRadius: "5px", display: "flex", alignItems: "center", justifyContent: "flex-end", marginTop: "20px" }}>Upload</span> : <></>}
                    </div>
                </Spin>
            </Modal>
        </>


    )
}

export default IncidentTab



